// extracted by mini-css-extract-plugin
module.exports = {"csr_h5_C":"C_csr_h5_C___W9g5"};